{
  "_provenance": {
    "ns": "tasks",
    "source": "pages/TasksPage.tsx, components/tasks/** and lib/task-display.ts (#2109 R3 lane L2)"
  },
  "auto": {
    "appointment_prep": {
      "description": "Review the appointment details and gather what you need.",
      "title": "Prep for {{appointment}}"
    },
    "post_chemo_recovery": {
      "description": "Soft foods stocked\nAnti-nausea med on schedule\nSoft blanket within reach\nHydration plan for the next 48h",
      "title": "Cycle {{cycle}}: post-chemo recovery checklist"
    },
    "refill_prep": {
      "descriptionDoctor": "Call {{doctor}} for a renewal. Dose: {{dose}}.",
      "descriptionDoctorNoDose": "Call {{doctor}} for a renewal. Dose: see record.",
      "descriptionPrescriber": "Call the prescriber for a renewal. Dose: {{dose}}.",
      "descriptionPrescriberNoDose": "Call the prescriber for a renewal. Dose: see record.",
      "title": "Refill {{medication}}",
      "titleWithDose": "Refill {{medication}} ({{dose}})"
    }
  },
  "callout": {
    "draftNudge": "Draft a nudge",
    "draftRide": "Draft a ride request",
    "noRide": {
      "today": "You haven’t asked for help with rides this week. {{title}} is today at {{time}}.",
      "tomorrow": "You haven’t asked for help with rides this week. {{title}} is tomorrow at {{time}}.",
      "weekday": "You haven’t asked for help with rides this week. {{title}} is {{weekday}} at {{time}}."
    },
    "nudgePrompt_one": "Help me draft a short, kind message to my circle about {{count}} urgent task that are still open.",
    "nudgePrompt_other": "Help me draft a short, kind message to my circle about {{count}} urgent tasks that are still open.",
    "quiet": "Things have been quiet on the help-list, but you have appointments coming up. Want me to suggest what to ask for?",
    "quietPrompt": "Things have been quiet on my help-list. What should I ask my circle for help with?",
    "rideTitle": "Ride to {{title}}",
    "talkTo": "Talk to {{companion}}",
    "urgentOpen_one": "One urgent task is still open. Want me to help nudge your circle?",
    "urgentOpen_other": "{{count}} urgent tasks are still open. Want me to help nudge your circle?",
    "viewUrgent": "View urgent tasks"
  },
  "category": {
    "childcare": "Childcare",
    "errand": "Errand",
    "hospital_stay": "Hospital",
    "meal": "Meal",
    "other": "Other",
    "ride": "Ride"
  },
  "filter": {
    "any": "Any",
    "category": "Category",
    "everyOccurrence": "Every occurrence",
    "oneCardPerSeries": "One card per series",
    "recurring": "Recurring",
    "show": "Show",
    "urgency": "Urgency"
  },
  "page": {
    "confirmCancel": {
      "confirm": "Cancel task",
      "description": "It comes off your list. There is no undo here.",
      "keep": "Keep task",
      "title": "Cancel “{{title}}”?"
    },
    "confirmCancelSeries": {
      "confirm": "Cancel recurring task",
      "description": "Every remaining occurrence comes off your list. There is no undo here.",
      "keep": "Keep recurring task",
      "title": "Cancel the whole recurring task “{{title}}”?"
    },
    "deepLinkMissing": "That task isn’t in this view — it may be filtered out or no longer exist.",
    "empty": {
      "addTask": "Add a task",
      "allDoneBody": "Everything on your list is finished. Add a task when you need a hand.",
      "allDoneTitle": "Nothing left to do",
      "body": "Add a task — rides, meals, appointments — and track them here.",
      "filteredBody": "Nothing on your list fits this search or these filters.",
      "filteredTitle": "No tasks match",
      "showAllTasks": "Show all tasks",
      "title": "Nothing on your list yet"
    },
    "filterLabel": "Filter your tasks",
    "hideDone": "Hide",
    "loadError": "Couldn’t load your tasks",
    "searchPlaceholder": "Search your tasks",
    "showAll": "Show all",
    "showDone": "Show",
    "toast": {
      "canceled": "Task canceled",
      "canceledBody": "The task has been canceled.",
      "cancelFailed": "Couldn’t cancel the task",
      "completed": "Task completed!",
      "completeFailed": "Couldn’t complete the task",
      "firstTask": "✓ First task created!",
      "firstTaskBody": "Great work — it’s on your family’s list.",
      "pleaseTryAgain": "Please try again",
      "seriesCanceled": "Recurring task canceled",
      "seriesCanceledBody": "The recurring task has been canceled.",
      "seriesCanceledCount_one": "{{count}} occurrence canceled.",
      "seriesCanceledCount_other": "{{count}} occurrences canceled.",
      "seriesCancelFailed": "Couldn’t cancel the recurring task"
    }
  },
  "recurrence": {
    "daily": "Daily",
    "everyDays_one": "Every {{count}} day",
    "everyDays_other": "Every {{count}} days",
    "everyMonths_one": "Every {{count}} month",
    "everyMonths_other": "Every {{count}} months",
    "everyWeeks_one": "Every {{count}} week",
    "everyWeeks_other": "Every {{count}} weeks",
    "monthly": "Monthly",
    "recurring": "Recurring",
    "weekly": "Weekly"
  },
  "request": {
    "add": "Add request",
    "adding": "Adding…",
    "editEyebrow": "Edit request",
    "editTitle": "Change what you need",
    "field": {
      "category": "Category",
      "details": "Anything helpful to know?",
      "time": "Time (optional)",
      "urgency": "Urgency",
      "what": "What is it?",
      "when": "When"
    },
    "footer": {
      "goes": "Goes on your family’s task list",
      "saved": "Saved to your family’s task list"
    },
    "newEyebrow": "New request",
    "newTitle": "What do you need a hand with?",
    "occurrenceOnly": "This changes only this occurrence.",
    "placeholder": {
      "details": "Times, address, special needs, who to call when they arrive…",
      "what": "e.g. Pick up Lila from school"
    },
    "toast": {
      "added": "Request added",
      "addedBody": "It’s on your task list — let your circle know what you need.",
      "addFailed": "Couldn’t add the request",
      "dateMissingBody": "When do you need this?",
      "saveFailed": "Couldn’t save the change",
      "titleMissingBody": "A few words on what you need.",
      "updated": "Request updated",
      "updatedBody": "The change is on your task list."
    }
  },
  "row": {
    "allDay": "All day",
    "cancelSeries": "Cancel recurring task",
    "cancelTask": "Cancel task",
    "dayDate": "{{weekday}} {{date}}",
    "dayDateTime": "{{weekday}} {{date}} · {{time}}",
    "done": "Done",
    "doneAria": "Done: {{title}}",
    "doneLower": "done",
    "doneOn": "Done {{date}}",
    "editTask": "Edit task",
    "hideDates": "Hide dates",
    "inProgress": "In progress",
    "markDoneAria": "Mark done: {{title}}",
    "markDoneTitle": "Mark done · {{urgency}}",
    "more_one": "{{count}} more",
    "more_other": "{{count}} more",
    "recurringTitle_one": "Recurring task · {{count}} occurrence total",
    "recurringTitle_other": "Recurring task · {{count}} occurrences total",
    "suggestedBy": "Suggested by {{companion}}",
    "suggestedByTitle": "{{companion}} staged this task automatically. You can dismiss or edit it like any other.",
    "weekdayTime": "{{weekday}} · {{time}}"
  },
  "status": {
    "all": "All",
    "completed": "Recently done",
    "in_motion": "In progress",
    "open": "To do"
  },
  "urgency": {
    "flexible": "Flexible",
    "soon": "Soon",
    "urgent": "Urgent"
  },
  "when": {
    "done": "Done",
    "later": "Later",
    "overdue": "Overdue",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "undated": "No date",
    "week": "Next seven days"
  }
}
